import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import check from '../../assets/icon/check.svg';

const CheckListWrapper = Styled.div`
max-width: 50rem;
display: grid;
grid-template-columns: repeat(3, 1fr);
grid-gap: 2rem;
`;

const CheckListInput = Styled.input.attrs(() => ({
  type: 'checkbox',
}))`
position: absolute;
top:0;
left:0;
width: 100%;
height: 100%;
cursor: pointer;
opacity: 0;
`;

const Option = Styled.article`
position: relative;
justify-self: flex-start;
`;

const OptionValue = Styled.span`
display: flex;
align-items: center;
justify-content: center;
`;

const Box = Styled.span`
display: flex;
align-items: center;
justify-content: center;
height: 2rem;
width: 2rem;
background-color: ${color.white};
border-radius: 4px;
margin-right:.5rem;
border: ${(props) => (props.error ? `solid 2px ${color.secondary}` : 'none')};
`;

class CheckList extends React.Component {
  state = {
    checked: false,
  };

  handleCheck = (event) => {
    this.props.onSelect(event);
  };

  render() {
    const { options } = this.props;
    return (
      <CheckListWrapper>
        {options.map(({ value, error, selected, onSelect }) => (
          <Option>
            <CheckListInput onClick={this.handleCheck} value={value} />
            <OptionValue>
              <Box error={error}>{selected && <img src={check} alt="" />}</Box>
              {value}
            </OptionValue>
          </Option>
        ))}
      </CheckListWrapper>
    );
  }
}

export default CheckList;
